
import { FooterNames } from '@/types/route';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({ name: "all-page-footer" })
export default class Footer extends Vue {

  get active() {
    const name = this.$route.meta?.footerName || this.$route.name as FooterNames

    if (!name) return -1;
    switch (name) {
      case "home":
        return 0;
      case "ocr-order-list":
        return 1;
      case "user-center":
        return 2;
      default: return -1;
    }
  }
  set active(v: number) { }

  navOnClick(name: FooterNames) {
    if (this.$route.name != name) this.$router.push({ name })
  }

  // 生命周期钩子
  created() {

  }
}
